import { type Conversation, type Paginator } from '@twilio/conversations'

const getSubscribedConversations = async (paginator: Paginator<Conversation>): Promise<Conversation[]> => {
  const items = paginator.items
  if (paginator.hasNextPage) {
    const nextPage = await paginator.nextPage()
    return [...items, ...(await getSubscribedConversations(nextPage))]
  } else {
    return items
  }
}

export default getSubscribedConversations
